// extracted by mini-css-extract-plugin
export default {"Hyperlink":"Hyperlink_Hyperlink__jitwP","InlineLink":"Hyperlink_InlineLink__q1g1T","SecondaryHyperlink":"Hyperlink_SecondaryHyperlink__t3n2o"};